import { frontendURL } from '../../../helper/URLHelper';
import { decideNaConta } from '../../../helper/escopos';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import canned from './canned/canned.routes';
import customRoles from './customRoles/customRoles.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import teams from './teams/teams.routes';
import profile from './profile/profile.routes';
import conversationWorkflow from './conversationWorkflow/conversationWorkflow.routes';
import powerAgents from './powerAgents/powerAgents.routes';
import powerData from './powerData/powerData.routes';
import powerApps from './powerapps/powerapps.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
        // ACESSO-01 (L8b): de todo membro da conta; quem decide é a tela para onde o redirecionamento leva.
        escopos: [],
      },
      redirect: to => {
        // ACESSO-01 (L8b): com a chave ACESSO_GRANULAR ligada, a tela Geral é de quem tem o `account:manage`, o
        // escopo da rota dela (travado: o super admin).
        const geral = decideNaConta(
          store.getters.getCurrentUser,
          to.params.accountId,
          'account:manage',
          () => store.getters.getCurrentRole === 'administrator'
        );
        if (geral) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...canned.routes,
    ...customRoles.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...teams.routes,
    ...profile.routes,
    ...conversationWorkflow.routes,
    ...powerAgents.routes,
    ...powerData.routes,
    ...powerApps.routes,
  ],
};
